// extracted by mini-css-extract-plugin
module.exports = {"iconwrapper":"votecard_iconwrapper__VkLuG","votewrapper":"votecard_votewrapper__3_X7o","votecard":"votecard_votecard__22IvA","decisionbox":"votecard_decisionbox__2-QHs"};